
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CompanyPage = lazy(() => import('../pages/company/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const EquipmentPage = lazy(() => import('../pages/equipment/page'));
const QualityPage = lazy(() => import('../pages/quality/page'));
const RecruitPage = lazy(() => import('../pages/recruit/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/company',
    element: <CompanyPage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/equipment',
    element: <EquipmentPage />,
  },
  {
    path: '/quality',
    element: <QualityPage />,
  },
  {
    path: '/recruit',
    element: <RecruitPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
